module.exports = __webpack_public_path__ + "static/media/phenotypes.ff96e5ec.svg";